// src/api/insuranceApi.js
import axiosClient from "./axiosClient";

//Create a new insurance policy
export const createInsurance = async (data) => {
  return axiosClient.post("/insurance/create/", data);
};

//Update an existing insurance policy
export const updateInsurance = async (insuranceId, data) => {
  return axiosClient.put(`/insurance/${insuranceId}/update/`, data);
};

//Delete an insurance policy
export const deleteInsurance = async (insuranceId) => {
  return axiosClient.delete(`/insurance/${insuranceId}/delete/`);
};

//Fetch details for a property or unit (includes insurance policies)
export const getInsuranceParentDetails = async (propertyId, unitId) => {
  const endpoint = unitId
    ? `/units/${unitId}/details/`
    : `/properties/${propertyId}/details/`;
  const res = await axiosClient.get(endpoint);
  return res.data;
};